import { render, staticRenderFns } from "./Bar3d.vue?vue&type=template&id=09aa5145&scoped=true&"
import script from "./Bar3d.vue?vue&type=script&lang=js&"
export * from "./Bar3d.vue?vue&type=script&lang=js&"
import style0 from "./Bar3d.vue?vue&type=style&index=0&id=09aa5145&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09aa5145",
  null
  
)

export default component.exports